import axios from "axios"
import { getCookie } from "./cookie"
// create an axios instance
const serive = axios.create({
  baseURL: process.env.BASE_API, // url = base url + request url
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 30000  // request timeout
})
// Add a request interceptor
serive.interceptors.request.use((config) => {
  // Do something before request is sent
  config.headers['token'] = getCookie('token') || ''
  if (config.method === 'post') {
    if (!config.data) {
      config.data = {}
    }
    config.data.language = getCookie('language') || 'zh'
  } else if (config.method === 'get') {
    if (!config.params) {
      config.params = {}
    }
    config.params.language = getCookie('language') || 'zh'
  }

  return config
}, error => {
  // Do something with request error
  return Promise.reject(error);
});

// Add a response interceptor
serive.interceptors.response.use(function (response) {
  // Any status code that lie within the range of 2xx cause this function to trigger
  // Do something with response data
  return response
}, function (error) {
  // Any status codes that falls outside the range of 2xx cause this function to trigger
  // Do something with response error
  if (error.response) {
    // The request was made and the server responded with a status code
    // that falls out of the range of 2xx
    console.error('Response error:', error.response.data);
    console.error('Response status:', error.response.status);
    console.error('Response headers:', error.response.headers);
    // You can add more specific error handling based on status codes here
  } else if (error.request) {
    // The request was made but no response was received
    console.error('Request error:', error.request);
  } else {
    // Something happened in setting up the request that triggered an Error
    console.error('Error:', error.message);
  }
  return Promise.reject(error);
});

export default serive
